import React from "react";
import GNILogo from '../images/Google_NewsInitiative_Lockup_White_Horizontal.svg'

import './style.scss';
import classnames from 'classnames'
import { getText } from '../languages'

export default function Footer(props) {
  const { language, isWorld, directionality } = props
  const isEmbed = props.embedParams !== null

  return (
    <footer className={classnames(directionality, { isEmbed })}>
      <div className='Footer'>
        <div className='section left'>
          <div className='content'>
            <div className='attribution'>
              {getText(language, 'creditsStart')}
              {' '}
              {
                isWorld
                  ? <a target='_blank' rel='noopener noreferrer' href='https://github.com/CSSEGISandData/COVID-19'>JHU CSSE COVID-19 Data</a>
                  : <a target='_blank' rel='noopener noreferrer' href='https://www.nytimes.com/interactive/2020/us/coronavirus-us-cases.html'>The New York Times</a>
              }
              <span className='hideOnSmallScreen'>
                {getText(language, isWorld ? 'creditsWorldEnd' : 'creditsUSEnd')}
              </span>
            </div>
            <div>
              <a href='https://biglocalnews.org/' target='_blank' rel='noopener noreferrer'>Big Local News</a>
              {' | '}
              <span className='hideOnSmallScreen'>{getText(language, 'supportedBy')} </span><a href='https://newsinitiative.withgoogle.com/about/' target='_blank' rel='noopener noreferrer'>Google News Initiative</a>
              {' | '}
              <span className='hideOnSmallScreen'>{getText(language, 'builtBy')} </span><a href='https://pitchinteractive.com/' target='_blank' rel='noopener noreferrer'>Pitch Interactive, Inc.</a>
            </div>
          </div>
        </div>
        <a href='https://newsinitiative.withgoogle.com/' className='googleLogo hideOnSmallScreen' target='_blank' rel='noopener noreferrer'>
          <img src={GNILogo} alt='Google News Initiative' />
        </a>
      </div>
    </footer>
  );
}